<template>
  <div>
    <el-dialog title="切换班级" :visible.sync="dialogVisible" width="672px" center="center" @close="closeDialog">
      <!-- 创建班级 -->
      <el-dialog class="zindex" width="672px" title="创建班级" :visible.sync="innerVisible1" append-to-body center="center">
        <el-form ref="form" :model="creatForm" label-width="0px">
          <el-form-item label="">
            <el-input v-model="creatForm.name" placeholder="请输入班级名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="creatForm.course_name" placeholder="请输入班级课程"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="innerVisible1 = false">取 消</el-button>
          <el-button size="small" style="background: #2881cd; border-color: #2881cd" type="primary" @click="creatClass">保
            存</el-button>
        </div>
      </el-dialog>
      <!-- 加入班级 -->
      <el-dialog width="672px" title="加入班级" :visible.sync="innerVisible2" append-to-body center="center">
        <el-form ref="formJoin" :model="joinForm" label-width="0px">
          <el-form-item label="">
            <!-- <el-select v-model="joinForm.cate" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              >
              </el-option>
            </el-select> -->
            <el-radio-group v-model="joinForm.cate" @change="changeRadio">
              <el-radio-button label="1" style="margin-right: 20px">老师</el-radio-button>
              <el-radio-button label="2" style="margin-left: 20px">学生</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="" v-if="joinForm.cate == 1">
            <el-input v-model="joinForm.course_name" placeholder="请输入课程名称"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="joinForm.class_code" placeholder="请输入班级码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="closeJoin">取 消</el-button>
          <el-button size="small" style="background: #2881cd; border-color: #2881cd" type="primary" @click="joinClass">保
            存</el-button>
        </div>
      </el-dialog>
      <div class="content flex">
        <div class="son" v-for="(item, index) in this.classList" :key="index">
          <div>
            <img style="cursor: pointer;" @click="cutClass(item, index)" src="../../assets/app_img/icon_class.png"
              alt="" />
          </div>
          <span>{{ item.class_name }}</span>
          <input v-if="item.cate === 1" :class="(focused && focusIndex === index) ? 'focused' : ''" type="text"
            v-model="item.course_name" @focus="focusInput(index)" @blur="lessonName(item, index)" />
          <div>{{ item.cate === 2 ? item.cate_name : '' }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small " icon="el-icon-refresh-left" @click="innerVisible1 = true">创建班级</el-button>
        <el-button type="primary" size="small " icon="el-icon-circle-plus-outline"
          @click="innerVisible2 = true">加入班级</el-button>
      </span>
    </el-dialog>

    <AddClass ref="addclass"></AddClass>
  </div>
</template>

<script>
import AddClass from "./addClass.vue"
import { mapState } from 'vuex'
export default {
  components: { AddClass },
  // props: ["qr_code"],
  inject: ["reload"], //注入
  data () {
    return {
      cupCount: 1,
      // cate: window.localStorage.getItem("cate"),
      radio1: "",
      dialogVisible: false,
      classList: "",
      innerVisible1: false,
      innerVisible2: false,
      creatForm: {},
      joinForm: {
        cate: "1",
      },
      options: [
        {
          value: "1",
          label: "老师",
        },
        {
          value: "2",
          label: "学生",
        },
      ],
      focused: false, //修改课程名称
      focusIndex: null,
      // value: '1'
    }
  },
  computed: {
    ...mapState({
      lesson: state => state.lesson,
      cate: state => state.cate,
      classInfo: state => state.classInfo
    })
  },
  methods: {
    closeDialog () {
      this.dialogVisible = true
      let class_name = window.localStorage.getItem("class_name")
      // class_name = '123'
      if (class_name == "undefined") {
        this.dialogVisible = true
        this.$message("请加入班级或者创建并加入班级")
      } else {
        this.dialogVisible = false
        // alert(123)
        // this.$message.error('请加入或者创建后加入班级')
      }
    },
    changeRadio (val) { },
    myCallBack () {
      // ...
      this.reload() //局部刷新
    },
    // 切换班级数据
    async cutClassData () {
      const res = await this.$axios.post("/base/class/list")
      if (res.status == 200 && res.data.errCode == 0) {
        this.classList = res.data.data
        if (this.classList.length == 1 && this.cupCount++ !== 1) {
          // this.cupCount++ ;
          // this.cutClass(this.classList[0])
          // console.log(this.cupCount++)
        }
      } else {
        // this.$message.error(res.data.message);
      }
    },
    // 切换班级
    async cutClass (item, index) {
      const { class_id } = item
      this.$store.dispatch('getClassInfo', class_id)


      const { data: res } = await this.$axios.post("/base/class/choose", {
        class_id: item.class_id,
        course_id: item.courses[0].id,
      })
      if (res.errCode == 0) {

        const { class_id, course_id, class_name, course_name, cate } = res.data
        // 更新localStorage中的内容
        window.localStorage.setItem("class_id", class_id)
        window.localStorage.setItem("course_id", course_id)
        window.localStorage.setItem("class_name", class_name)
        window.localStorage.setItem("course_name", course_name)
        window.localStorage.setItem("cate", cate)

        this.$store.dispatch("getCate", cate)
        this.$store.dispatch("getClassInfo")
        this.$store.dispatch("getLesson", index)
        this.dialogVisible = false
        // window.location.reload();
      } else {
        console.log(res.message)
      }
    },
    // 创建班级
    async creatClass () {
      const res = await this.$axios.post("/base/class/create", {
        name: this.creatForm.name,
        course_name: this.creatForm.course_name,
      })
      if (res.status == 200 && res.data.errCode == 0) {
        console.log(res.data.data)
        // window.localStorage.setItem('cate',)
        this.innerVisible1 = false
        this.cutClassData()
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 加入班级
    async joinClass () {
      this.joinForm.cate = this.joinForm.cate.toString()
      const res = await this.$axios.post("/base/class/join", this.joinForm)
      if (res.status == 200 && res.data.errCode == 0) {
        this.cutClassData()
        this.innerVisible2 = false
        // window.location.reload();
      } else {
        this.$message.error(res.data.message)
      }
    },
    // 取消
    closeJoin () {
      this.$nextTick(() => {
        this.$refs["formJoin"].clearValidate()
      })
      this.innerVisible2 = false
    },
    // 修改课程名称输入框聚焦
    focusInput (index) {
      this.focusIndex = index
      this.focused = true
    },
    async lessonName (item, index) {
      const { class_id, course_id } = item
      this.focused = false
      const res = await this.$axios.post("/base/class/set/course/name", {
        // course_id: window.localStorage.getItem("course_id"),
        course_id: course_id !== null ? course_id : 0,
        name: item.course_name,
        class_id: class_id
      })
      // console.log(res);
      if (res.status == 200 && res.data.errCode == 0) {
        window.localStorage.setItem("course_name", item.course_name)
        this.cutClassData()
        this.$store.dispatch("getLesson", index)
        this.$store.dispatch("getClassInfo")
        // this.$emit("changes", item);
        // window.location.reload();
      } else {
        this.cutClassData()
      }
    },
    // 班级信息接口
  },
}
</script>
<style lang="scss" scoped>
.zindex {
  z-index: 100000 !important;
}

/deep/ .el-form {
  width: 400px;
  margin: auto;
}

/deep/ .el-input__inner {
  width: 100%;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #f1f4f6;
}

/deep/ .el-dialog__body {
  text-align: center !important;
}

/deep/ .el-dialog__title {
  font-weight: bold;
}

.flex {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}

.content {
  text-align: center;

  img {
    margin-top: 30px;
    width: 30px;
    height: 30px;
  }

  .son {
    // margin-bottom: 15px;
    width: 130px;
    height: 112px;
    background: #f4f4f5;
    margin: 0 10px 15px;
  }
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-radio-button__inner {
  border: 1px solid #dcdfe6;
  border-radius: 4px !important;
  padding: 11px 40px;
}

/deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  background-color: rgb(40, 129, 205);
  border-color: rgb(40, 129, 205);
}

input {
  text-align: center;
  width: 80%;
  display: block;
  margin: auto;
  border: none;
  background: none;
  color: #606266;
}

input:focus {
  outline: none;
}

.son input {
  height: 20px;
}

.focused {
  height: 20px;
  background: #fff;
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/cutDialog.vue